<!-- Loading spinner -->
@if (this.loadingService.loading$()) {
    <div class="loading-container flex-content-center">
        <div class="spinner-grow text-primary loading-spinner" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
}
<!-- the application -->
<div class="container-fluid bg-body-tertiary">
    @if (this.authService.isLoggedIn() && !applicationContextStore.isWebViewMode() && !applicationContextStore.isCustomerView()) {
        <div class="row">
            <marlin-web-header (toggleTheme)="toggleTheme()" [isDarkTheme]="themeService.isDarkTheme()" class="p-0"></marlin-web-header>
        </div>
    }
    <div class="row">
        @if (this.authService.isLoggedIn() && !applicationContextStore.isWebViewMode() && !applicationContextStore.isCustomerView()) {
            <lib-web-sidemenu [menuItems]="menuItems" class="col-sm-auto sticky-top d-none d-md-block"></lib-web-sidemenu>
        }

        <div
            [ngClass]="applicationContextStore.isCustomerView()
                ? 'w-100 p-0 vh-100'
                : 'col-sm min-vh-80 bg-body-secondary m-2 rounded'"
        >
            <router-outlet />
        </div>
    </div>
    @if (this.authService.isLoggedIn() && !applicationContextStore.isWebViewMode() && !applicationContextStore.isCustomerView()) {
        <div class="row">
            <marlin-web-footer></marlin-web-footer>
        </div>
    }
</div>

<div kendoDialogContainer></div>
